import Slider from '../Slider';
import DestacatInformatiu from './DestacatInformatiu';
import styles from './informatiusDestacats.module.scss';

const InformatiusDestacatsSkeleton = (props) => {
    const { titol, skeletonItems } = props;

    return (
        <div className={styles.contDestacatInformatiu}>
            <Slider format='poster-informatiu-destacat' titol={titol}>
                {Array.from({ length: skeletonItems }, (_, index) => (
                    <DestacatInformatiu key={`poster-informatiu-destacat-skeleton-${index}`} isLoading={true} />
                ))}
            </Slider>
        </div>
    );
};

InformatiusDestacatsSkeleton.defaultProps = {
    skeletonItems: 4
};

export default InformatiusDestacatsSkeleton;
